import React from 'react';
import { mdiPaperclip } from '@mdi/js';
import Icon from '@mdi/react';
import styled from 'styled-components';
import { IconSize } from '../../../../lib';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
const AttachmentViewerContainer = styled.div `
    display: flex;
    align-items: center;

    svg {
        margin-right: 8px;
    }
`;
export const AttachmentViewer = ({ componentValues }) => {
    var _a;
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(AttachmentViewerContainer, null,
            React.createElement(Icon, { path: mdiPaperclip, size: IconSize.Small }),
            React.createElement("a", { title: "Download attachment", href: componentValues.url, target: "_blank", rel: "noreferrer" }, (_a = componentValues.linkText) !== null && _a !== void 0 ? _a : 'Download attachment'))));
};
//# sourceMappingURL=index.js.map